import React from 'react';
import { ButtonHandle } from '@progress/kendo-react-buttons';
import styles from './index.module.scss';
import CardAction from '@components-clean/core/card/card-actions';

type Props = {
    ref?: React.Ref<ButtonHandle>;
    'data-testid': string;
    collapsed: boolean;
    setCollapsed: (newValue: boolean) => void;
};

const CardCollapseButton = ({ ref, 'data-testid': dataTestid, collapsed, setCollapsed }: Props) => {
    return (
        <CardAction
            ref={ref}
            data-testid={dataTestid}
            data-collapsed={collapsed}
            className={styles.button}
            faIcon={['fas', 'chevron-down']}
            onClick={() => setCollapsed(!collapsed)}
        />
    );
};

export default CardCollapseButton;
